module.exports = "../study/imgs/maps/Nagano/S8/Hazard/Beach/Nagano_Beach_MRI_RCP85_End.png";